import { render, staticRenderFns } from "./SectionBreakdown.vue?vue&type=template&id=07408cd0&scoped=true&"
import script from "./SectionBreakdown.vue?vue&type=script&lang=js&"
export * from "./SectionBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./SectionBreakdown.vue?vue&type=style&index=0&id=07408cd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07408cd0",
  null
  
)

export default component.exports